import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CustomContentWrapper from './CustomContentWrapper';
import ImageContentUploader from './ImageContentUploader';
import ImageDescriptionTextfield from './ImageDescriptionTextfield';
import ImageHeadingTextfield from './ImageHeadingTextfield';
import TextContentBody from './TextContentBody';
import TextContentHeading from './TextContentHeading';
import { FormValues } from '../../types';
import { useTranslation } from 'services/localization';

export interface Props {
	sectionIndex: number;
	contentIndex: number;
}
const CustomContentController = (props: Props) => {
	const { sectionIndex, contentIndex } = props;

	const { t } = useTranslation();
	const { control } = useFormContext<FormValues>();
	return (
		<Controller
			name={`onlineLayout.about.customContent.sections.${sectionIndex}.content.${contentIndex}`}
			control={control}
			render={({ field }) => {
				switch (field.value?.type) {
					case 'image':
						return (
							<CustomContentWrapper
								title={t('channels.online.customizer.customContent.image', 'Image')}
								onDelete={() =>
									field.onChange({
										src: null,
										heading: null,
										description: null,
									})
								}
							>
								<ImageContentUploader sectionIndex={sectionIndex} contentIndex={contentIndex} />
								<ImageHeadingTextfield sectionIndex={sectionIndex} contentIndex={contentIndex} />
								<ImageDescriptionTextfield
									sectionIndex={sectionIndex}
									contentIndex={contentIndex}
								/>
							</CustomContentWrapper>
						);
					case 'text':
						return (
							<CustomContentWrapper
								title={t('channels.online.customizer.customContent.text', 'Text')}
								onDelete={() =>
									field.onChange({
										heading: null,
										body: null,
									})
								}
							>
								<TextContentHeading sectionIndex={sectionIndex} contentIndex={contentIndex} />
								<TextContentBody sectionIndex={sectionIndex} contentIndex={contentIndex} />
							</CustomContentWrapper>
						);
					default:
						return <></>;
				}
			}}
		/>
	);
};

export default CustomContentController;
